import type { EntityState } from '../../lib/api.js';
import { domainOf } from '../../lib/utils.js';
import { LightCard } from './LightCard.js';
import { SwitchCard } from './SwitchCard.js';
import { SensorCard } from './SensorCard.js';
import { ClimateCard } from './ClimateCard.js';
import { LockCard } from './LockCard.js';
import { CoverCard } from './CoverCard.js';
import { FanCard } from './FanCard.js';
import { MediaPlayerCard } from './MediaPlayerCard.js';
import { DefaultCard } from './DefaultCard.js';

interface Props {
  entityId: string;
  entity: EntityState;
}

export function EntityCard({ entityId, entity }: Props) {
  const domain = domainOf(entityId);
  switch (domain) {
    case 'light':
      return <LightCard entityId={entityId} entity={entity} />;
    case 'switch':
    case 'input_boolean':
      return <SwitchCard entityId={entityId} entity={entity} />;
    case 'sensor':
    case 'binary_sensor':
      return <SensorCard entityId={entityId} entity={entity} />;
    case 'climate':
      return <ClimateCard entityId={entityId} entity={entity} />;
    case 'lock':
      return <LockCard entityId={entityId} entity={entity} />;
    case 'cover':
      return <CoverCard entityId={entityId} entity={entity} />;
    case 'fan':
      return <FanCard entityId={entityId} entity={entity} />;
    case 'media_player':
      return <MediaPlayerCard entityId={entityId} entity={entity} />;
    default:
      return <DefaultCard entityId={entityId} entity={entity} />;
  }
}
